import Icon from "@cloudscape-design/components/icon"

/**
 * Tab ids of the DTA details page, in display order. The `?tab=` URL param holds one of these.
 */
export const DTA_TAB_IDS = ["overview", "editor", "collaboration", "audit-trail"] as const

/**
 * A tab id of the DTA details page.
 */
export type DtaTabId = (typeof DTA_TAB_IDS)[number]

/**
 * Tab-strip labels, shared by the loaded page and its loading skeleton so the strip is identical.
 */
export const DTA_TAB_LABELS: Record<DtaTabId, React.ReactNode> = {
  overview: (
    <>
      <Icon name="view-horizontal" size="normal" /> Overview
    </>
  ),
  editor: (
    <>
      <Icon name="edit" size="normal" /> Details
    </>
  ),
  collaboration: (
    <>
      <Icon name="contact" size="normal" /> Collaboration
    </>
  ),
  "audit-trail": (
    <>
      <Icon name="status-pending" size="normal" /> Audit Trail
    </>
  ),
}
